import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import Paper from "@material-ui/core/Paper";
import MySelect from "../CustomChallan/MySelect";
import makeAnimated from "react-select/animated";
import { components } from "react-select";
import { PremissionChecker } from "../../../services/PremissionChecker";
function CampusClasses() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const animatedComponents = makeAnimated();
  const [loading, setloading] = useState(false);
  const authtoken = localStorage.getItem("userToken");
  const [assignModal, setAssignModal] = useState(false);
  const [optionSelected, setoptionSelected] = useState([]);
  const [allsubjects, setallsubjects] = useState([]);
  const [selectedsubjects, setselectedsubjects] = useState([]);
  const [isanysubject, setisanysubject] = useState(false);
  const [updateloading, setupdateloading] = useState(false);
  const [fullClass, setFullClass] = useState({});
  const [assginClassName, setAssginClassName] = useState("");
 
  const [isallfields, setisallfields] = useState(false);
  const [courseClassData, setCourseClassData] = useState([]);
  const [courseData, setCourseData] = useState([]);
  const [classesData, setClassesData] = useState([]);
  const [addClassLoading, setAddClassLoading] = useState(false);

  const [addClassModal, setAddClassModal] = useState(false);
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");

  const [editClassModal, setEditClassModal] = useState(false);
  const [editCourseClassId, setEditCourseClassId] = useState("");
  const [editCourseId, setEditCourseId] = useState("");
  const [editClassId, setEditClassId] = useState("");

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteableClass, setDeleteableClass] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    getAllSubjects();
    getCourses();
    getClasses();
  }, []);

  const getCourses = async () => {
    setloading(true);
    await fetch(`${baseUrl}/course`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const getClasses = async () => {
    setloading(true);
    await fetch(`${baseUrl}/studentclasses`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassesData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const getAllSubjects = () => {
    fetch(`${baseUrl}/subject`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsubjects(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  
  const getCourseClasses = async (courseId) => {
    setloading(true);
     setCourseClassData([]);
    await fetch(`${baseUrl}/course-all-classes/${courseId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseClassData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const addClassHandler = async () => {
    if (courseId == "" || classId == "") {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      course_id: courseId,
      student_class_id: classId,
    };
    setAddClassLoading(true);

    await fetch(`${baseUrl}/course-class`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            setAddClassModal(false);
            setAddClassLoading(false);
            getCourseClasses(courseId);
            alert.success("Class successfully added");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddClassModal(false);
            setAddClassLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddClassModal(false);
            setAddClassLoading(false);
          }
        })
      )
      .catch((err) => {
        setAddClassLoading(false);
        setAddClassModal(false);
        console.log(err);
      });
  };

  const updateCourseClassHandler = async () => {
    if (editCourseId == "" || editClassId == "") {
      return alert.error("Seletct Course / Class Is Required");
    }

    setSubmitLoading(true);
    const data = {
      course_id: editCourseId,
      student_class_id: editClassId,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/course-class/${editCourseClassId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Class Successfully Updated");
            getCourseClasses(courseId);
            setEditClassModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditClassModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditClassModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteClassHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/course-class/${deleteableClass}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getCourseClasses(courseId);
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  const getAssignSubjects = (courseClass) => {
    setFullClass(courseClass);
    fetch(`${baseUrl}/assigned-subjects-of-class/${courseClass?.id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((res) => {
          let arr = [];
          res.payload.map((item) => {
            arr.push({ value: item.id, label: item.name });
          });
          setoptionSelected(arr);
          setAssignModal(true);
        });
      })

      .catch((err) => {
        console.log(err);
      });
  };

  const assignedSubjects = () => {
    setupdateloading(true);
    let formdata = new FormData();

    formdata.append("course_class_id", fullClass.id);

    for (let i = 0; i < selectedsubjects.length; i++) {
      formdata.append(`subject_ids[${i}]`, selectedsubjects[i]);
    }

    fetch(`${baseUrl}/subjects-assign-to-classes`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          alert.success("Subjects update successfully");
          setupdateloading(false);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            alert.error(msg);
            setupdateloading(false);
          });
        }
        setAssignModal(false);
      })
      .catch((err) => {
        setupdateloading(false);
        console.log(err);
      });
  };

  const handleChangeSubjects = (selected) => {
    if (optionSelected.length == 30 && selected.length == 30) {
      setoptionSelected([]);
      return;
    }
    setoptionSelected([...selected]);
    let valuearray = [];

    selected.map((item, index) => {
      valuearray[index] = item.value;
    });
    setselectedsubjects([...valuearray]);
    if (valuearray.length == 0) {
      setisanysubject(true);
      return;
    }
    setisanysubject(false);
  };

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );
  
  const Options = [];
  allsubjects.map((item, index) => {
    Options[index] = { value: item.id, label: item.name };
  });

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddClassModal(true)}
            className="btn btn-primary mr-2"
          >
            Add Class
          </button>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <label>
              <b>Select Course</b> <span style={{ color: "red" }}>*</span>
            </label>
            <div className="d-flex flex-column">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="campus_id"
                aria-label="Default select example"
                onChange={(e) => {
                  onCourseChange(e.target.value);
                }}
                value={courseId}
              >
                <option value="">
                  {" "}
                  Select Course
                </option>
                {courseData &&
                  courseData.map((item, index) => (
                    <option key={index} value={item.id}>{item.name}</option>
                  ))}
              </select>
            </div>
          </div>
        </div>
        <Table style={{ margin: 10 }}>
          <thead>
            <tr className="text-center">
              <th>ID</th>
              <th>Class Name</th>
              <th>Assign Subjects</th>
              <th>Update</th>
              {PremissionChecker(user, "campus.can_delete_class") ? (
              <th>Delete</th>
               ) : null}
            </tr>
          </thead>
          <tbody>
            {courseClassData?.map((courseClass, index) => (
              <tr className="text-center" key={index}>
                <td>{courseClass.id}</td>
                <td>{courseClass?.class?.name}</td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => {getAssignSubjects(courseClass); setAssginClassName(courseClass?.class?.name)}}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                      />
                    </span>
                  </a>
                </td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => {
                      setEditCourseClassId(courseClass.id);
                      setEditCourseId(courseClass.course_id);
                      setEditClassId(courseClass.student_class_id);
                      setEditClassModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Files/Download.svg"
                        )}
                      />
                    </span>
                  </a>
                </td>
                {PremissionChecker(user, "campus.can_delete_class") ? (
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => {
                      setDeleteableClass(courseClass?.id);
                      setdeleteModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Delete-user.svg"
                        )}
                      />
                    </span>
                  </a>
                </td>
               ) : null}
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

{/* Assign Subject Modal */}
        <Modal show={assignModal}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Assign Subjects To {assginClassName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group col-sm-12 flex-column d-flex">
              <label>
                <b>
                  Select subjects <span style={{ color: "red" }}>*</span>
                </b>
              </label>
              <MySelect
                options={Options}
                isMulti
                name="selectedOptions"
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                components={{ Option, MultiValue, animatedComponents }}
                onChange={handleChangeSubjects}
                allowSelectAll={true}
                value={optionSelected}
              />
            </div>
          </Modal.Body>

          {isanysubject ? (
          <>
            <Alert
              variant="danger"
              onClose={() => setisanysubject(false)}
              dismissible
            >
              <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
              <p>Please Add Some Subject</p>
            </Alert>
          </>
        ) : null}

          <Modal.Footer>
          {updateloading ? (
              <Spinner class="text-center" variant="info" animation="border" />
            ) : (
              <button onClick={assignedSubjects} className="btn button_blue">
                Assign
              </button>
            )}

            <button
              onClick={() => setAssignModal(false)}
              className="btn btn-danger btn_width"
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Add Campus Course Modal */}
        <Modal show={addClassModal} size="md">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add Course Class
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-4">
              <label htmlFor="course">
                Select Course<span style={{ color: "red" }}>*</span>
              </label>

              <select
                className="form-select form-control"
                name="course"
                onChange={(e) => {
                  if (e.value == 0) {
                    setisallfields(true);
                  } else {
                    setisallfields(false);
                  }
                  setCourseId(e.target.value);
                }}
                style={{ backgroundColor: "white" }}
                aria-label="Default select example"
              >
                <option value="">Select Course</option>
                {courseData.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="row mb-4">
              <label htmlFor="class_id">
                Select Class<span style={{ color: "red" }}>*</span>
              </label>
              <select
                style={{ height: 40 }}
                className="form-select form-control"
                name="class_id"
                aria-label="Default select example"
                onChange={(e) => {
                  setClassId(e.target.value);
                }}
              >
                <option value=""> Select Class</option>
                {classesData &&
                  classesData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addClassLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addClassHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddClassModal(false);
                setisallfields(false);
                setCourseId("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Campus Course Modal */}
        <Modal show={editClassModal} size="md">
          <Modal.Header>
            <Modal.Title>Update Course Class</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-4">
              <label htmlFor="course">
                Select Course<span style={{ color: "red" }}>*</span>
              </label>

              <select
                className="form-select form-control"
                name="course"
                onChange={(e) => {
                  if (e.value == 0) {
                    setisallfields(true);
                  } else {
                    setisallfields(false);
                  }
                  setEditCourseId(e.target.value);
                }}
                value={editCourseId}
                style={{ backgroundColor: "white" }}
                aria-label="Default select example"
              >
                <option value="">Select Course</option>
                {courseData.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="row mb-4">
              <label htmlFor="class_id">
                Select Class<span style={{ color: "red" }}>*</span>
              </label>
              <select
                style={{ height: 40 }}
                className="form-select form-control"
                name="class_id"
                aria-label="Default select example"
                onChange={(e) => {
                  setEditClassId(e.target.value);
                }}
                value={editClassId}
              >
                <option value=""> Select Class</option>
                {classesData &&
                  classesData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateCourseClassHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditClassModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Campus Course Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this course class?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Fee Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button onClick={deleteClassHandle} className="btn button_blue">
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default CampusClasses;
